<template>
  <!-- 
        导航 
             el-menu   导航主体                 
             el-submenu   - 导航容器项（内部有子菜单）               
             el-menu-item-group   - 导航分组容器（用于将导航项目分组，并命名）   
             el-menu-item  - 最终导航项         
    -->
  <!-- 激活路由 -->
  <!-- <el-scrollbar class="scrllbar" style="background: #f6f7fb">
    <div>
      <el-menu
        @select="handleSelect"
        @open="handleOpen"
        :router="true"
        :unique-opened="true"
        :default-active="routepath"
        class="active"
        style="background: #f6f7fb"
        id="abc"
      >
        <el-submenu index="/Personal-Center" class="width100 submenu">
          <template #title>
            <div :class="activebgindex == 14 ? 'activebg' : ''">
              <svg
                width="14px"
                height="16px"
                viewBox="0 0 14 16"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                :class="activebgindex == 14 ? 'activecorlor' : ''"
              >
                <path
                  d="M6.91539342,-0.0490433061 C8.9507038,-0.0952209734 10.6386513,1.53597431 10.6860596,3.59411799 C10.6809811,4.76464063 10.1154994,5.86144359 9.15757302,6.44803413 C11.4769464,7.30557574 13.0281075,9.52936551 13.0499954,12.0276522 C13.0352973,13.1073409 12.1973181,13.9809176 11.1479437,14.046065 L10.9966611,14.0498072 L3.0040344,14.0498024 C1.88496325,14.0653701 0.965410735,13.159352 0.950001375,12.0266008 C0.968521904,9.52974176 2.5193838,7.30569291 4.82911736,6.53567678 C3.88212395,5.86214458 3.31735466,4.765832 3.31228263,3.59279746 C3.35480971,1.66650914 4.83952785,0.102848198 6.71954779,-0.0394379112 L6.91539342,-0.0490433061 Z M2.13847401,12.0261474 C2.14574976,12.4674455 2.47493327,12.8239463 2.89491485,12.8699008 L3.00166813,12.874789 L10.9973982,12.8745809 C11.4683019,12.8795582 11.8535369,12.500469 11.8598683,12.0283327 C11.7888016,9.4186838 9.71319643,7.32047869 7.13216504,7.24865232 C4.44711255,7.17515775 2.21118286,9.3150573 2.13847401,12.0261474 Z M6.9361502,1.00612469 C5.55651188,1.04086712 4.46635494,2.19917219 4.50074615,3.59487451 C4.51960558,4.91511058 5.55069616,5.98307063 6.83635246,6.05176175 L7.0605109,6.05510542 C8.44046991,6.02035492 9.53029819,4.86342199 9.49592502,3.46856082 C9.46154394,2.07337807 8.31574858,0.971383268 6.9361502,1.00612469 Z"
                  id="个人中心"
                ></path>
              </svg>
              <span class="pad-left20">个人中心</span>
            </div>
          </template>
          <div class="width100" style="height: 10px"></div>
          <el-menu-item index="/Personal-Center/Trademarks-Concern">
            <template #title>
              <span>我关注的商标</span>
            </template>
          </el-menu-item>
          <div class="width100" style="height: 10px"></div>
          <el-menu-item index="/Personal-Center/Trademark-Sharing">
            <template #title>
              <span>我分享的商标</span>
            </template>
          </el-menu-item>
          <div class="width100" style="height: 10px"></div>
          <el-menu-item index="/Personal-Center/Enterprises-Interest">
            <template #title>
              <span>我关注的企业</span>
            </template>
          </el-menu-item>
          <div class="width100" style="height: 10px"></div>
          <el-menu-item index="/Personal-Center/Enterprises-Sharing">
            <template #title>
              <span @click="totrfa()">我分享的企业</span>
            </template>
          </el-menu-item>
          <div class="width100" style="height: 10px"></div>
          <el-menu-item index="/Personal-Center/patent-Interest">
            <template #title>
              <span>我关注的专利</span>
            </template>
          </el-menu-item>
          <div class="width100" style="height: 10px"></div>
          <el-menu-item index="/Personal-Center/patent-Sharing">
            <template #title>
              <span>我分享的专利</span>
            </template>
          </el-menu-item>
          <div class="width100" style="height: 10px"></div>
          <el-menu-item index="/Personal-Center/Enterprise-Certification">
            <template #title>
              <span>企业认证申请</span>
            </template>
          </el-menu-item>
          <div class="width100" style="height: 10px"></div>
          <el-menu-item index="/Personal-Center/joined-enterprise">
            <template #title>
              <span>我加入的企业</span>
            </template>
          </el-menu-item>
          <div class="width100" style="height: 10px"></div>
          <el-menu-item index="/Personal-Center/message-reminds">
            <template #title>
              <span>我的消息提醒</span>
            </template>
          </el-menu-item>
          <div class="width100" style="height: 10px"></div>
          <el-menu-item index="/Personal-Center/reminder-schedule">
            <template #title>
              <span>我的日程提醒</span>
            </template>
          </el-menu-item>
          <div class="width100" style="height: 10px"></div>
          <el-menu-item index="/Personal-Center/Sharing-Management">
            <template #title>
              <span>文件分享管理</span>
            </template>
          </el-menu-item>
        </el-submenu>
        <div class="width100" style="height: 10px; padding-bottom: 40px"></div>
      </el-menu>
    </div>
  </el-scrollbar> -->
  <div class="width100 cursorpointer">
    <div class="width83 margin-auto">
      <div>
        <p
          :class="menuclass == 1 ? 'menuclassitem' : ''"
          @click="topersonalhomepage"
        >
          <img
            :class="menuclass == 1 ? 'menufilter' : ''"
            class="perimg"
            src="@/assets/barsvg/15grzx.svg"
            alt=""
          />
          <span class="pad-left20"> 个人中心 </span>
        </p>
      </div>
      <div>
        <div class="f12 menuitem">企业</div>
        <div>
          <p
            :class="menuclass == 2 ? 'menuclassitem' : ''"
            @click="toEnterprisesInterest"
          >
            <img
              :class="menuclass == 2 ? 'menufilter' : ''"
              src="@/assets/barsvg/qy-gz.svg"
              alt=""
            /><span class="pad-left20"> 我关注的企业 </span>
          </p>
          <p
            :class="menuclass == 3 ? 'menuclassitem' : ''"
            @click="toEnterprisesSharing"
          >
            <img
              :class="menuclass == 3 ? 'menufilter' : ''"
              src="@/assets/barsvg/qy-fx.svg"
              alt=""
            /><span class="pad-left20"> 我分享的企业 </span>
          </p>
          <p
            :class="menuclass == 4 ? 'menuclassitem' : ''"
            @click="tojoinedenterprise"
          >
            <img
              :class="menuclass == 4 ? 'menufilter' : ''"
              src="@/assets/barsvg/qy-jr.svg"
              alt=""
            /><span class="pad-left20"> 我加入的企业 </span>
          </p>
          <p
            :class="menuclass == 5 ? 'menuclassitem' : ''"
            @click="toEnterpriseCertification"
          >
            <img
              :class="menuclass == 5 ? 'menufilter' : ''"
              src="@/assets/barsvg/qy-rz.svg"
              alt=""
            /><span class="pad-left20"> 企业认证申请 </span>
          </p>
        </div>
      </div>
      <div>
        <div class="f12 menuitem">专利</div>
        <div>
          <p
            :class="menuclass == 6 ? 'menuclassitem' : ''"
            @click="topatentInterest"
          >
            <img
              :class="menuclass == 6 ? 'menufilter' : ''"
              src="@/assets/barsvg/zl-gz.svg"
              alt=""
            /><span class="pad-left20"> 我关注的专利 </span>
          </p>
          <p
            :class="menuclass == 7 ? 'menuclassitem' : ''"
            @click="topatentSharing"
          >
            <img
              :class="menuclass == 7 ? 'menufilter' : ''"
              src="@/assets/barsvg/zl-fx.svg"
              alt=""
            /><span class="pad-left20"> 我分享的专利 </span>
          </p>
        </div>
      </div>
      <div>
        <div class="f12 menuitem">商标</div>
        <div>
          <p
            :class="menuclass == 8 ? 'menuclassitem' : ''"
            @click="toTrademarksConcern"
          >
            <img
              :class="menuclass == 8 ? 'menufilter' : ''"
              src="@/assets/barsvg/sb-gz.svg"
              alt=""
            /><span class="pad-left20"> 我关注的商标 </span>
          </p>
          <p
            :class="menuclass == 9 ? 'menuclassitem' : ''"
            @click="toTrademarkSharing"
          >
            <img
              :class="menuclass == 9 ? 'menufilter' : ''"
              src="@/assets/barsvg/sb-fx.svg"
              alt=""
            /><span class="pad-left20"> 我分享的商标 </span>
          </p>
        </div>
      </div>
      <div>
        <div class="f12 menuitem">政策</div>
        <div>
          <p
            :class="menuclass == 10 ? 'menuclassitem' : ''"
            @click="toPolicysubscription"
          >
            <img
              :class="menuclass == 10 ? 'menufilter' : ''"
              src="@/assets/barsvg/qt-wdydzc.svg"
              alt=""
            /><span class="pad-left20"> 我订阅的政策 </span>
          </p>
        </div>
      </div>
      <div>
        <div class="f12 menuitem">其他</div>
        <div>
          <p
            :class="menuclass == 11 ? 'menuclassitem' : ''"
            @click="tomessagereminds"
          >
            <img
              :class="menuclass == 11 ? 'menufilter' : ''"
              src="@/assets/barsvg/qt-xxtx.svg"
              alt=""
            /><span class="pad-left20"> 我的消息提醒 </span>
          </p>
          <p
            :class="menuclass == 12 ? 'menuclassitem' : ''"
            @click="toreminderschedule"
          >
            <img
              :class="menuclass == 12 ? 'menufilter' : ''"
              src="@/assets/barsvg/qt-rctx.svg"
              alt=""
            /><span class="pad-left20"> 我的日程提醒 </span>
          </p>
          <p
            :class="menuclass == 13 ? 'menuclassitem' : ''"
            @click="toSharingManagement"
          >
            <img
              :class="menuclass == 13 ? 'menufilter' : ''"
              src="@/assets/barsvg/qt-wjfxgl.svg"
              alt=""
            /><span class="pad-left20"> 文件分享管理 </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return { menuclass: "" };
  },
  computed: {},
  watch: {
    $route() {
      if (this.$route.fullPath == "/Personal-Center/personal-homepage") {
        this.menuclass = 1;
      } else if (
        this.$route.fullPath == "/Personal-Center/Enterprises-Interest"
      ) {
        this.menuclass = 2;
      } else if (
        this.$route.fullPath == "/Personal-Center/Enterprises-Sharing"
      ) {
        this.menuclass = 3;
      } else if (this.$route.fullPath == "/Personal-Center/joined-enterprise") {
        this.menuclass = 4;
      } else if (
        this.$route.fullPath == "/Personal-Center/Enterprise-Certification"
      ) {
        this.menuclass = 5;
      } else if (this.$route.fullPath == "/Personal-Center/patent-Interest") {
        this.menuclass = 6;
      } else if (this.$route.fullPath == "/Personal-Center/patent-Sharing") {
        this.menuclass = 7;
      } else if (
        this.$route.fullPath == "/Personal-Center/Trademarks-Concern"
      ) {
        this.menuclass = 8;
      } else if (this.$route.fullPath == "/Personal-Center/Trademark-Sharing") {
        this.menuclass = 9;
      } else if (
        this.$route.fullPath == "/Science-technology/Policy-subscription"
      ) {
        this.menuclass = 10;
      } else if (this.$route.fullPath == "/Personal-Center/message-reminds") {
        this.menuclass = 11;
      } else if (this.$route.fullPath == "/Personal-Center/reminder-schedule") {
        this.menuclass = 12;
      } else if (
        this.$route.fullPath == "/Personal-Center/Sharing-Management"
      ) {
        this.menuclass = 13;
      }
    },
  },
  methods: {
    // 个人中心首页
    topersonalhomepage() {
      this.$router.push({ path: "/Personal-Center/personal-homepage" });
    },
    // 我关注的企业
    toEnterprisesInterest() {
      this.$router.push({ path: "/Personal-Center/Enterprises-Interest" });
    },
    // 我分享的企业
    toEnterprisesSharing() {
      this.$router.push({ path: "/Personal-Center/Enterprises-Sharing" });
    },
    // 我加入的企业
    tojoinedenterprise() {
      this.$router.push({ path: "/Personal-Center/joined-enterprise" });
    },
    // 企业认证申请
    toEnterpriseCertification() {
      this.$router.push({ path: "/Personal-Center/Enterprise-Certification" });
    },
    // 我关注的专利
    topatentInterest() {
      this.$router.push({ path: "/Personal-Center/patent-Interest" });
    },
    // 我分享的专利
    topatentSharing() {
      this.$router.push({ path: "/Personal-Center/patent-Sharing" });
    },
    // 我关注的商标
    toTrademarksConcern() {
      this.$router.push({ path: "/Personal-Center/Trademarks-Concern" });
    },
    // 我分享的商标
    toTrademarkSharing() {
      this.$router.push({ path: "/Personal-Center/Trademark-Sharing" });
    },
    // 我的消息提醒
    tomessagereminds() {
      this.$router.push({ path: "/Personal-Center/message-reminds" });
    },
    // 我的日程提醒
    toreminderschedule() {
      this.$router.push({ path: "/Personal-Center/reminder-schedule" });
    },
    // 文件分享管理
    toSharingManagement() {
      this.$router.push({ path: "/Personal-Center/Sharing-Management" });
    },
    // 政策
    toPolicysubscription() {
      this.$router.push({ path: "/Science-technology/Policy-subscription" });
    },
  },
  created() {
    if (this.$route.fullPath == "/Personal-Center/personal-homepage") {
      this.menuclass = 1;
    } else if (
      this.$route.fullPath == "/Personal-Center/Enterprises-Interest"
    ) {
      this.menuclass = 2;
    } else if (this.$route.fullPath == "/Personal-Center/Enterprises-Sharing") {
      this.menuclass = 3;
    } else if (this.$route.fullPath == "/Personal-Center/joined-enterprise") {
      this.menuclass = 4;
    } else if (
      this.$route.fullPath == "/Personal-Center/Enterprise-Certification"
    ) {
      this.menuclass = 5;
    } else if (this.$route.fullPath == "/Personal-Center/patent-Interest") {
      this.menuclass = 6;
    } else if (this.$route.fullPath == "/Personal-Center/patent-Sharing") {
      this.menuclass = 7;
    } else if (this.$route.fullPath == "/Personal-Center/Trademarks-Concern") {
      this.menuclass = 8;
    } else if (this.$route.fullPath == "/Personal-Center/Trademark-Sharing") {
      this.menuclass = 9;
    } else if (
      this.$route.fullPath == "/Science-technology/Policy-subscription"
    ) {
      this.menuclass = 10;
    } else if (this.$route.fullPath == "/Personal-Center/message-reminds") {
      this.menuclass = 11;
    } else if (this.$route.fullPath == "/Personal-Center/reminder-schedule") {
      this.menuclass = 12;
    } else if (this.$route.fullPath == "/Personal-Center/Sharing-Management") {
      this.menuclass = 13;
    }
  },
  mounted() {},
};
</script>

<style scoped>
p {
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  margin-top: 10px;
  color: #6a7589;
  cursor: pointer;
}
.menuclassitem {
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  margin-top: 10px;
  background: #52c5cb;
  color: #fff;
  cursor: pointer;
  border-radius: 20px;
}

p:hover {
  height: 40px;
  background: #52c5cb;
  color: #fff;
  border-radius: 20px;
}

img {
  position: relative;
  left: 12px;
  top: 2px;
  /* transform: translateY(-60px);
  filter: drop-shadow(#333333 0 60px); */
}
.menufilter {
  transform: translatex(-60px) !important;
  filter: drop-shadow(#fff 60px 0) !important;
}
.perimg {
  position: relative;
  left: 12px;
  top: 2px;
  transform: translatex(-60px);
  filter: drop-shadow(#6a7589 60px 0);
}
.menuitem {
  margin: 20px 0 0 10px;
}
</style>
